// extracted by mini-css-extract-plugin
export default {"Title":"HelpList_Title__Z4NDe"};